import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'
import buildChoices from './buildChoices'

const LEVELS_MIN = 2
const LEVELS_MAX = 4

export default function cascadeDropDownBuilder({ rawField }: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  const levels = Math.min(Math.max(rawField.levels ?? LEVELS_MIN, LEVELS_MIN), LEVELS_MAX)

  return {
    levels,
    choices: buildChoices(rawField.choices, false, levels),
  }
}
